import { IconProps } from './index';

const HeartStroke: React.VFC<IconProps> = ({ title, titleId, ...props }: IconProps) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            d="M4.738 1.213c.324.142.618.347.886.627l.645.691.731.784.731-.784.645-.691c.268-.28.562-.485.886-.627.323-.142.66-.213 1.02-.213.359 0 .696.07 1.019.213a2.774 2.774 0 0 1 1.328 1.245c.123.235.215.477.278.728.062.25.093.502.093.758 0 .261-.03.518-.09.771a2.956 2.956 0 0 1-.725 1.334L7 11.544 1.815 6.05a2.775 2.775 0 0 1-.444-.62 3.304 3.304 0 0 1-.279-.724A3.06 3.06 0 0 1 1 3.951c0-.267.03-.526.09-.778a2.96 2.96 0 0 1 .723-1.332c.267-.28.562-.486.886-.628.323-.142.66-.213 1.02-.213s.696.07 1.02.213Z"
            stroke="currentColor"
            strokeWidth={2}
        />
    </svg>
);

export default HeartStroke;
